import { useEffect } from "react";
import { showToast } from "@/utils/toast";
import { startWebUpdateWatch } from "@/utils/webUpdate";
import { toastText } from "@/utils/toastTemplates";

// Whodat's update banner, grown up: the watcher compares the main bundle's
// content hash against the server's (checked every 5 minutes and whenever the
// tab comes back into view), heals a stale tab whose lazy chunks a deploy
// removed, and a newer build shows the standard toast with a one-tap Refresh
// (message editable in admin under Automatic toasts, "Website updated").
// Skipped in the native app, which updates through the stores. Mounted in
// both shells; the watcher itself only ever runs once.
export default function UpdateNotifier() {
  useEffect(() => startWebUpdateWatch(() => {
    showToast(toastText("web_update_available", {}, "A new version is available"), {
      duration: 0,
      cssClass: "wd-toast wd-toast-invert",
      buttons: [{ text: "Refresh", handler: () => { window.location.reload(); return false; } }],
    });
  }), []);
  return null;
}
